module.exports = __webpack_public_path__ + "static/media/github.ce7dadae.svg";